export default __webpack_public_path__ + "static/media/faq-category-icon-1.7d8cc4e3.svg";